import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ModuleWrapper from './ModuleWrapper.vue';

import SelectBrandKit from '@/studio/brandKit/SelectBrandKit.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBrandKitModule',
  props: {
    moduleId: { default: 'selectBrandKit' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Select Brand Kit"
  }, {
    main: _withCtx(() => [
      _createVNode(SelectBrandKit)
    ]),
    _: 1
  }, 8, ["moduleId"]))
}
}

})